import { HeaderCell } from './HeaderCell';
import { ORDERED_TABLE_COLUMNS, TABLE_COLUMNS } from '../constants';
import { useTranslation } from '../../../hooks';

const LABELS: Record<TABLE_COLUMNS, string> = {
  [TABLE_COLUMNS.NAME]: 'name',
  [TABLE_COLUMNS.MEDIUM]: 'medium',
  [TABLE_COLUMNS.TYPE]: 'type',
  [TABLE_COLUMNS.STATUS]: 'status',
  [TABLE_COLUMNS.LAST_MODIFIED]: 'lastModified',
};

const headerColumns = ORDERED_TABLE_COLUMNS.map((id) => ({
  columnId: id,
  label: LABELS[id],
}));

export const HeaderRow = () => {
  const { t } = useTranslation();

  return (
    <>
      {headerColumns.map((column) => (
        <HeaderCell
          {...column}
          label={t(`insights.listUsage.${column.label}`)}
          key={column.columnId}
        />
      ))}
    </>
  );
};
